
import parallel from 'async/parallel'
import './delivery-regions.tag'
import './delivery-condition-param-modal.tag'
import './delivery-condition-regions-modal.tag'
import 'components/week-days-checkbox.tag'
import 'components/catalog-tree-check.tag'
riot.tag2('delivery-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/delivery"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;deliveries&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4" onclick="{wipedata}">{isNew ? item.name || \'Добавление типа доставки\' : item.name || \'Редактирование типа доставки\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#delivery-edit-delivery">Доставка</a></li>\n      <li if="{~regions.indexOf(item.code)}"><a data-toggle="tab" href="#delivery-edit-terms-of-pricing">Условия формирования цен</a></li>\n      <li><a data-toggle="tab" href="#delivery-edit-setup-payments">Настройка оплат</a></li>\n      <li><a data-toggle="tab" href="#delivery-edit-product-groups">Группы товаров</a></li>\n      <li if="{~regions.indexOf(item.code)}"><a data-toggle="tab" href="#delivery-edit-regions-geolocation">Регионы геолокации</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="delivery-edit-delivery">\n          <div class="row">\n            <div class="col-md-3">\n              <div class="form-group {has-error: error.name}">\n                <label class="control-label">Наименование</label>\n                <input class="form-control" name="name" value="{item.name}">\n                <div class="help-block">{error.name}</div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group {has-error: error.code}">\n                <label class="control-label">Способ доставки</label>\n                <select class="form-control" name="code" value="{item.code}" onchange="{isExt}">\n                  <option each="{deliveriesTypes}" value="{code}" __selected="{code == item.code}" no-reorder>{name}</option>\n                </select>\n                <div class="help-block">{error.code}</div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group {has-error: error.currency}">\n                <label class="control-label">Валюта</label>\n                <select class="form-control" name="currency" value="{item.curr}">\n                  <option each="{c, i in currencies}" value="{c.name}" __selected="{c.name == item.curr}" no-reorder>{c.title}</option>\n                </select>\n                <div class="help-block">{error.currency}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{isIn}">\n              <div class="form-group">\n                <label class="control-label">Дни недели</label><br>\n                <week-days-checkbox name="week" value="{item.week}"></week-days-checkbox>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-3" if="{isIn}">\n              <div class="form-group">\n                <label class="control-label">Время в пути (1, 1-3)</label>\n                <input class="form-control" name="period" type="text" value="{item.period}">\n              </div>\n            </div>\n            <div class="col-md-3" if="{true}">\n              <div class="form-group">\n                <label class="control-label">Базовая цена</label>\n                <input class="form-control" name="price" min="0" step="0.01" value="{item.price}" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Макс. вес</label>\n                <div class="input-group">\n                  <input class="form-control" name="maxWeight" min="0" step="0.01" value="{item.maxWeight}" type="{\'number\'}"><span class="input-group-addon">гр</span>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Макс. объем</label>\n                <div class="input-group">\n                  <input class="form-control" name="maxVolume" min="0" step="1" value="{item.maxVolume}" type="{\'number\'}"><span class="input-group-addon">см<sup>3</sup></span>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group {has-error: error.sms}">\n                <label class="control-label">SMS-уведомление</label>\n                <input class="form-control" name="sms" type="phone" value="{item.sms}">\n                <div class="help-block">{error.sms}</div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group {has-error: error.email}">\n                <label class="control-label">Email-уведомление</label>\n                <input class="form-control" name="email" type="text" value="{item.email}">\n                <div class="help-block">{error.email}</div>\n              </div>\n            </div>\n          </div>\n          <hr>\n          <div class="row treasure" if="{!isIn}">\n            <div class="col-md-3" if="{fields.from_index}">\n              <div class="form-group">\n                <label class="control-label">{fields.from_index.name}</label>\n                <input class="form-control" id="treasure{fields.from_index.code} " name="{fields.from_index.code}" type="{fields.from_index.type}" value="{fields.from_index.value}">\n                <div class="help-block" if="{fields.from_index.description}"><i class="icon-append fa fa-info-circle"></i> {fields.from_index.description}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.declared_value}">\n              <div class="form-group">\n                <div class="checkbox-inline">\n                  <label class="control-label">\n                    <input name="{fields.declared_value.code}" type="checkbox" __checked="{fields.declared_value.value}">{fields.declared_value.name}\n                  </label>\n                </div>\n                <div class="help-block" if="{fields.declared_value.description}"><i class="icon-append fa fa-info-circle"></i> {fields.declared_value.description}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.type_delivery}">\n              <div class="form-group">\n                <label class="control-label">{fields.type_delivery.name}</label>\n                <select class="form-control" id="treasuretype_delivery " name="type_delivery">\n                  <option each="{val, i in fields.type_delivery.values}" __selected="{val == fields.type_delivery.value}" value="{val}" no-reorder>{i}</option>\n                </select>\n                <div class="help-block" if="{fields.type_delivery.description}"><i class="icon-append fa fa-info-circle"></i> {fields.type_delivery.description}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.from_city}">\n              <div class="form-group">\n                <label class="control-label">{fields.from_city.name}</label>\n                <input class="form-control" id="treasure{fields.from_city.code} " name="{fields.from_city.code}" autocomplete="off" oninput="{cityChange}" datavalue="{fields.from_city.value}" value="{fields.from_city.valueName}" type="text">\n                <div class="help-block">\n                  <ul class="list-group from-city-list">\n                    <li class="list-group-item" each="{i in fields.from_city.values}" value="{i.id}" onclick="{citySet}" title="{i.region}, {i.country}">{i.city}</li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.login}">\n              <div class="form-group">\n                <label class="control-label">{fields.login.name}</label>\n                <input class="form-control" id="treasure{fields.login.code}" name="{fields.login.code}" type="text" value="{fields.login.value}" autocomplete="off">\n                <div class="help-block" if="{fields.login.description}"><i class="icon-append fa fa-info-circle"></i> {fields.login.description}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.password}">\n              <div class="form-group">\n                <label class="control-label">{fields.password.name}</label>\n                <input class="form-control" id="treasure{fields.password.code}" name="{fields.password.code}" type="password" value="{fields.password.value}" autocomplete="off">\n                <div class="help-block" if="{fields.password.description}"><i class="icon-append fa fa-info-circle"></i> {fields.password.description}</div>\n              </div>\n            </div>\n            <div class="col-md-3" if="{fields.map_key}">\n              <div class="form-group">\n                <label class="control-label">{fields.map_key.name}</label>\n                <input class="form-control" id="treasure{fields.map_key.code}" name="{fields.map_key.code}" type="text" value="{fields.map_key.value}" autocomplete="off">\n                <div class="help-block" if="{fields.map_key.description}"><i class="icon-append fa fa-info-circle"></i> {fields.map_key.description}</div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Примечание</label>\n                <textarea class="form-control" name="note" rows="5" style="min-width: 100%; max-width: 100%;" value="{item.note}"></textarea>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="isActive" type="checkbox" __checked="{item.isActive}">Активная\n                  </label>\n                </div>\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="onePosition" type="checkbox" __checked="{item.onePosition}">Для одной позиции\n                  </label>\n                </div>\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="needAddress" type="checkbox" __checked="{item.needAddress}">Требовать адрес\n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="delivery-edit-terms-of-pricing" if="{~regions.indexOf(item.code)}">\n          <div class="row">\n            <div class="col-md-12">\n              <ul class="nav nav-tabs m-b-2">\n                <li class="active"><a data-toggle="tab" href="#delivery-edit-terms-of-pricing-params">По параметрам</a></li>\n                <li><a data-toggle="tab" href="#delivery-edit-terms-of-pricing-regions">По регионам</a></li>\n              </ul>\n              <div class="tab-content">\n                <div class="tab-pane fade in active" id="delivery-edit-terms-of-pricing-params">\n                  <catalog-static name="conditionsParams" rows="{item.conditionsParams}" cols="{conditionsParamsCols}" handlers="{conditionsParamsHandlers}" add="{conditionsParamsEdit}" dblclick="{conditionsParamsEdit}" remove="true">\n                    <yield to="body">\n                      <datatable-cell name="name">{row.name}</datatable-cell>\n                      <datatable-cell name="formatPrice">{handlers.formatPrice(row)}</datatable-cell>\n                      <datatable-cell name="typeParam">{handlers.typeParam[row.typeParam]}</datatable-cell>\n                      <datatable-cell name="minValue">{row.minValue}</datatable-cell>\n                      <datatable-cell name="maxValue">{row.maxValue}</datatable-cell>\n                      <datatable-cell name="priority">{row.priority}</datatable-cell>\n                    </yield>\n                  </catalog-static>\n                </div>\n                <div class="tab-pane fade" id="delivery-edit-terms-of-pricing-regions">\n                  <catalog-static name="conditionsRegions" rows="{item.conditionsRegions}" cols="{conditionsRegionsCols}" handlers="{conditionsRegionsHandlers}" add="{conditionsRegionsEdit}" dblclick="{conditionsRegionsEdit}" remove="true">\n                    <yield to="body">\n                      <datatable-cell name="name">{row.name}</datatable-cell>\n                      <datatable-cell name="geo">{handlers.locationTextRender(row)}</datatable-cell>\n                      <datatable-cell name="price">{row.price}</datatable-cell>\n                      <datatable-cell name="period">{row.period} дн.</datatable-cell>\n                      <datatable-cell name="note">{row.note}</datatable-cell>\n                    </yield>\n                  </catalog-static>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="delivery-edit-setup-payments">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog object="PaySystem" cols="{paysystemsCols}" disable-col-select="true" handlers="{paysystemsHandlers}">\n                <yield to="body">\n                  <datatable-cell name="name"><i class="fa fa-fw {handlers.checked.indexOf(row.id) &gt; -1 ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.toggleCheckbox}"></i> {row.name}</datatable-cell>\n                </yield>\n              </catalog>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="delivery-edit-product-groups">\n          <div class="row">\n            <div class="col-md-12">\n              <catalog-tree-check object="Category" label-field="{&quot;name&quot;}" hidepanel="false" children-field="{&quot;childs&quot;}" remove="{remove}" handlers="{productsGroupsHandlers}" store="delivery-edit-product-groups"></catalog-tree-check>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="delivery-edit-regions-geolocation" if="{~regions.indexOf(item.code)}">\n          <catalog-static name="geoLocationsRegions" rows="{item.geoLocationsRegions}" handlers="{geoLocationsRegionsHandlers}" add="{addGeoLocationsRegions}" cols="{geoLocationsRegionsCols}" dblclick="{geoLocationsRegionsEdit}" remove="true">\n            <yield to="body">\n              <datatable-cell name="name">{handlers.locationTextRender(row)}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '.from-city-list li { cursor: pointer; } .from-city-list li:hover { background-color: #337ab7; color: #fff; }', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.mixin('validation');
self.mixin('permissions');
self.mixin('change');
self.item = {};
self.isIn = false;
self.citiesItems = {};
self.hidePanel = true;

function locationTextRender(item) {
    if (item.idCityTo) {
        var _self$citiesItems$ite = self.citiesItems[item.idCityTo],
            idCountry = _self$citiesItems$ite.idCountry,
            idRegion = _self$citiesItems$ite.idRegion,
            city = _self$citiesItems$ite.name;
        var country = self.countriesItems[idCountry].name;

        if (idRegion != 0) {
            var region = self.regionsItems[idRegion].name;

            return country + ', ' + region + ', ' + city;
        } else return country + ', ' + city;
    }

    if (item.idRegionTo) {
        var _self$regionsItems$it = self.regionsItems[item.idRegionTo],
            _idCountry = _self$regionsItems$it.idCountry,
            _region = _self$regionsItems$it.name;
        var _country = self.countriesItems[_idCountry].name;

        return _country + ', ' + _region;
    }

    if (item.idCountryTo) {
        return self.countriesItems[item.idCountryTo].name;
    }
}

self.rules = {
    name: 'empty',
    code: 'empty',
    currency: 'empty',
    email: {
        required: false,
        rules: [{
            type: 'email'
        }]
    },
    sms: {
        required: false,
        rules: [{
            type: 'phone'
        }]
    }
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.regions = ['region', 'subregion'];

self.isExt = function (e) {
    self.deliveriesTypes.forEach(function (item) {
        if (e.target.value == item.code) {
            self.isIn = item.isIn;
            self.fields = item.fields;
        }
    });
};

self.cityChange = function (e) {
    if (e.target.value.length > 1) {
        API.request({
            object: 'DeliveryType',
            method: 'Info',
            data: {
                type: 'city',
                value: e.target.value
            },
            success: function success(response) {
                self.fields.from_city.values = response;
                if (self.fields.from_city.values.length == 1) {
                    self.fields.from_city.values.forEach(function (item) {
                        self.fields.from_city.value = item.id;
                        self.fields.from_city.valueName = item.city;
                        e.target.value = item.city;
                        self.fields.from_city.values = null;
                    });
                } else {
                    console.log(response);
                    self.update();
                }
            }
        });
    } else {
        self.fields.from_city.values = null;
    }
};

self.citySet = function (e) {
    e.preventDefault();
    self.fields.from_city.value = e.target.value;
    self.fields.from_city.valueName = e.target.innerText;

    if (self.fields.from_city.valueName == e.target.innerText) {
        self.fields.from_city.values = null;
    }
    $('#treasurefrom_city').val(e.target.innerText);
    //self.update()
};

self.paysystemsCols = [{ name: 'name', value: 'Наименование' }];

self.productsGroupsCols = [{ name: '', value: '', width: '30px' }, { name: 'name', value: 'Наименование' }];

self.conditionsParamsCols = [{ name: 'name', value: 'Наименование' }, { name: 'formatprice', value: 'цена' }, { name: 'typeParam', value: 'Аргумент' }, { name: 'minValue', value: 'Мин. знач.' }, { name: 'maxValue', value: 'Макс. знач.' }, { name: 'priority', value: 'Приоритет' }];

self.conditionsRegionsCols = [{ name: 'name', value: 'Наименование' }, { name: 'geo', value: 'Страна/Регион/Город' }, { name: 'price', value: 'Цена' }, { name: 'period', value: 'Срок' }, { name: 'note', value: 'Адрес склада/примечание' }];

self.conditionsRegionsHandlers = {
    locationTextRender: locationTextRender
};

self.geoLocationsRegionsCols = [{ name: 'name', value: 'Страна/Регион/Город' }];

self.conditionsParamsHandlers = {
    typeParam: {
        sum: 'Сумма',
        weight: 'Вес',
        volume: 'Объем'
    },
    formatPrice: function formatPrice(row) {
        var result = '';
        var operation = row.operation,
            typePrice = row.typePrice,
            price = row.price;

        price = price || 0;

        if (typePrice === 'a') {
            switch (operation) {
                case '=':
                    result = '' + price;
                    break;
                case '+':
                    result = '+' + price + ' \u043A \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0441\u0443\u043C\u043C\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
                    break;
                case '-':
                    result = '-' + price + ' \u043E\u0442 \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
                    break;
            }
        }

        if (typePrice === 's') {
            switch (operation) {
                case '=':
                    result = price + '% \u043E\u0442 \u0441\u0443\u043C\u043C\u044B \u0437\u0430\u043A\u0430\u0437\u0430';
                    break;
                case '+':
                    result = '+' + price + '% \u0441\u0443\u043C\u043C\u044B \u0437\u0430\u043A\u0430\u0437\u0430 \u043A \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
                    break;
                case '-':
                    result = '-' + price + '% \u0441\u0443\u043C\u043C\u044B \u0437\u0430\u043A\u0430\u0437\u0430 \u043E\u0442 \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
                    break;
            }
        }

        if (typePrice === 'd') {
            switch (operation) {
                case '=':
                    result = (price || 0) + '% \u043E\u0442 \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
                    break;
                case '+':
                    result = 100 + price + '% \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
                    break;
                case '-':
                    result = 100 - price + '% \u0431\u0430\u0437\u043E\u0432\u043E\u0439 \u0446\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438';
                    break;
            }
        }

        return result;
    }
};

self.conditionsParamsEdit = function (e) {
    var item = void 0;

    if (e && e.item) item = e.item.row;

    modals.create('delivery-condition-param-modal', {
        type: 'modal-primary',
        item: item,
        formatPrice: self.conditionsParamsHandlers.formatPrice,
        submit: function submit() {
            var _this = this;
            if (!item) {
                self.item.conditionsParams.push(_this.item);
            }

            self.update();
            _this.modalHide();
        }
    });
};

self.conditionsRegionsEdit = function (e) {
    var item = void 0;

    if (e && e.item) item = e.item.row;

    modals.create('delivery-condition-regions-modal', {
        type: 'modal-primary',
        item: item,
        submit: function submit() {
            if (this.tags.idCityTo.value) {
                self.citiesItems[this.tags.idCityTo.value] = {};
                self.citiesItems[this.tags.idCityTo.value].name = this.tags.idCityTo.filterValue;

                if (this.tags.idRegionTo.value) self.citiesItems[this.tags.idCityTo.value].idRegion = this.tags.idRegionTo.value;else self.citiesItems[this.tags.idCityTo.value].idRegion = 0;

                if (this.tags.idCountryTo.value) self.citiesItems[this.tags.idCityTo.value].idCountry = this.tags.idCountryTo.value;else self.citiesItems[this.tags.idCityTo.value].idCountry = 0;
            }

            var _this = this;
            if (!item) {
                self.item.conditionsRegions.push(_this.item);
            }

            self.update();
            _this.modalHide();
        }
    });
};

self.geoLocationsRegionsHandlers = {
    locationTextRender: locationTextRender
};

self.paysystemsHandlers = {
    checked: [],
    toggleCheckbox: function toggleCheckbox(e) {
        var idx = this.handlers.checked.indexOf(this.row.id);

        if (idx > -1) this.handlers.checked.splice(idx, 1);else this.handlers.checked.push(this.row.id);

        self.update();
    }
};

self.productsGroupsHandlers = {
    checked: [],
    toggleCheckbox: function toggleCheckbox(e) {
        var idx = self.productsGroupsHandlers.checked.indexOf(this.row.id);

        if (idx > -1) self.productsGroupsHandlers.checked.splice(idx, 1);else self.productsGroupsHandlers.checked.push(this.row.id);

        self.update();
    }
};

self.addGeoLocationsRegions = function (e) {
    modals.create('delivery-regions', {
        type: 'modal-primary',
        submit: function submit() {
            var item = {
                idCountryTo: this.tags.idCountryTo.value,
                idRegionTo: this.tags.idRegionTo.value,
                idCityTo: this.tags.idCityTo.value
            };

            if (this.tags.idCityTo.value) {
                self.citiesItems[this.tags.idCityTo.value] = {};
                self.citiesItems[this.tags.idCityTo.value].name = this.tags.idCityTo.filterValue;

                if (this.tags.idRegionTo.value) self.citiesItems[this.tags.idCityTo.value].idRegion = this.tags.idRegionTo.value;else self.citiesItems[this.tags.idCityTo.value].idRegion = 0;

                if (this.tags.idCountryTo.value) self.citiesItems[this.tags.idCityTo.value].idCountry = this.tags.idCountryTo.value;else self.citiesItems[this.tags.idCityTo.value].idCountry = 0;
            }

            self.item.geoLocationsRegions = self.item.geoLocationsRegions || [];
            self.item.geoLocationsRegions.push(item);
            this.modalHide();
            self.update();
        }
    });
};

self.geoLocationsRegionsEdit = function (e) {
    modals.create('delivery-regions', {
        type: 'modal-primary',
        item: e.item.row,
        submit: function submit() {
            if (this.tags.idCityTo.value) {
                self.citiesItems[this.tags.idCityTo.value] = {};
                self.citiesItems[this.tags.idCityTo.value].name = this.tags.idCityTo.filterValue;

                if (this.tags.idRegionTo.value) self.citiesItems[this.tags.idCityTo.value].idRegion = this.tags.idRegionTo.value;else self.citiesItems[this.tags.idCityTo.value].idRegion = 0;

                if (this.tags.idCountryTo.value) self.citiesItems[this.tags.idCityTo.value].idCountry = this.tags.idCountryTo.value;else self.citiesItems[this.tags.idCityTo.value].idCountry = 0;
            }

            this.parent.item.idCountryTo = this.tags.idCountryTo.value;
            this.parent.item.idRegionTo = this.tags.idRegionTo.value;
            this.parent.item.idCityTo = this.tags.idCityTo.value;
            this.modalHide();
            self.update();
        }
    });
};
self.wipedata = function (e) {
    var fields = [];

    for (var i in self.fields) {
        var field = [];
        switch (self.fields[i].code) {
            case 'from_city':
                field['value'] = document.getElementsByName(self.fields[i].code)[0].getAttribute('datavalue');
                break;
            default:
                field['value'] = document.getElementsByName(self.fields[i].code)[0].value;
                break;
        }
        field['code'] = self.fields[i].code;
        fields.push(field);
    }
};

self.submit = function () {
    self.error = self.validation.validate(self.item, self.rules);
    if (!self.error) {
        (function () {

            var items = self.tags['catalog-tree-check'].getSelectedNodes();
            var itemsList = [];
            items.forEach(function (item) {
                itemsList.push(item.id);
            });
            self.item.idsGroups = itemsList;

            self.loader = true;

            /* Сохраняем основные настройки */

            API.request({
                object: 'Delivery',
                method: 'Save',
                data: self.item,
                success: function success(response) {
                    self.item = response;
                    observable.trigger('delivery-reload');
                    popups.create({ title: 'Успех!', text: 'Тип доставки сохранен!', style: 'popup-success' });
                    /* Сохраняем дополнительные настройки */
                    var fields = [];

                    for (var i in self.fields) {
                        var field = {};
                        switch (self.fields[i].code) {
                            case 'from_city':
                                field.value = document.getElementsByName(self.fields[i].code)[0].getAttribute('datavalue');
                                break;
                            default:
                                if (document.getElementsByName(self.fields[i].code)[0] != null) field.value = document.getElementsByName(self.fields[i].code)[0].value;
                                break;
                        }
                        field.code = self.fields[i].code;
                        fields.push(field);
                    }
                    API.request({
                        object: 'DeliveryType',
                        method: 'Info',
                        data: {
                            fields: fields,
                            id_delivery: self.item.id,
                            type: 'save'
                        },
                        success: function success(response) {}
                    });
                },
                complete: function complete() {
                    self.loader = false;
                    self.update();
                }
            });
        })();
    } else {
        popups.create({ title: 'Ошибка!', text: 'Ошибка заполнения данных!', style: 'popup-danger' });
    }
};

self.reload = function () {
    observable.trigger('delivery-edit', self.item.id);
};

observable.on('delivery-edit', function (id) {
    var params = { id: id };
    self.error = false;
    self.isNew = false;
    self.item = {};
    self.loader = true;
    //self.update()
    self.tags['catalog-tree-check'].tags['treeview-check'].deselectAll();
    parallel([function (callback) {
        API.request({
            object: 'Delivery',
            method: 'Info',
            data: params,
            success: function success(response) {
                self.item = response;
                self.deliveriesTypes = response.deliveriesTypes;

                self.deliveriesTypes.forEach(function (item) {
                    if (self.item.code == item.code) {
                        self.isIn = item.isIn;
                    }
                    if (item.isIn == false && !item.fields) {

                        API.request({
                            object: 'DeliveryType',
                            method: 'Info',
                            data: {
                                type: 'settings',
                                id_delivery: self.item.id,
                                code: item.code
                            },
                            success: function success(response) {
                                item.fields = response;
                                if (self.item.code == item.code) {
                                    self.fields = response;
                                }
                                self.update();
                            }
                        });
                    }
                });
                self.currencies = response.currencies;
                self.paysystemsHandlers.checked = response.idsPaySystems || [];
                self.productsGroupsHandlers.checked = response.idsGroups || [];
                self.update();
                callback(null, 'Deliveries');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    }], function (err, res) {
        if (self.item.geoLocationsRegions && self.item.geoLocationsRegions instanceof Array) {
            var geoLocationsRegionsIds = self.item.geoLocationsRegions.map(function (item) {
                return item.idCityTo;
            }).filter(function (item) {
                return item;
            });
            var conditionsRegionsIds = self.item.conditionsRegions.map(function (item) {
                return item.idCityTo;
            }).filter(function (item) {
                return item;
            });
            API.request({
                object: 'GeoCity',
                method: 'Fetch',
                data: { ids: [].concat(geoLocationsRegionsIds, conditionsRegionsIds) },
                success: function success(response) {
                    self.citiesItems = {};

                    response.items.forEach(function (item) {
                        self.citiesItems[item.id] = {
                            idCountry: item.idCountry,
                            idRegion: item.idRegion,
                            name: item.name
                        };
                    });

                    self.loader = false;
                    self.tags['catalog-tree-check'].tags['treeview-check'].setNodes(self.productsGroupsHandlers.checked);
                    self.update();
                }
            });
        } else {
            self.loader = false;
            self.update();
        }
    });
});

observable.on('delivery-new', function () {
    self.error = false;
    self.isNew = true;
    self.item = {};
    parallel([function (callback) {
        API.request({
            object: 'DeliveryType',
            method: 'Fetch',
            success: function success(response) {
                self.deliveriesTypes = response.items;
                callback(null, 'Deliveries');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    }, function (callback) {
        API.request({
            object: 'Currency',
            method: 'Fetch',
            success: function success(response) {
                self.currencies = response.items;
                callback(null, 'Deliveries');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    }], function (err, res) {
        if (self.item.geoLocationsRegions && self.item.geoLocationsRegions instanceof Array) {
            var geoLocationsRegionsIds = self.item.geoLocationsRegions.map(function (item) {
                return item.idCityTo;
            }).filter(function (item) {
                return item;
            });
            var conditionsRegionsIds = self.item.conditionsRegions.map(function (item) {
                return item.idCityTo;
            }).filter(function (item) {
                return item;
            });
            API.request({
                object: 'GeoCity',
                method: 'Fetch',
                data: { ids: [].concat(geoLocationsRegionsIds, conditionsRegionsIds) },
                success: function success(response) {
                    self.citiesItems = {};

                    response.items.forEach(function (item) {
                        self.citiesItems[item.id] = {
                            idCountry: item.idCountry,
                            idRegion: item.idRegion,
                            name: item.name
                        };
                    });

                    self.loader = false;
                    self.update();
                }
            });
        } else {
            self.loader = false;
            self.update();
        }
    });
});

self.on('mount', function () {
    API.request({
        object: 'GeoCountry',
        method: 'Fetch',
        success: function success(response) {
            self.countriesItems = {};
            response.items.forEach(function (item) {
                self.countriesItems[item.id] = { code: item.code, name: item.name };
            });
            self.update();
        }
    });
    API.request({
        object: 'GeoRegion',
        method: 'Fetch',
        success: function success(response) {
            self.regionsItems = {};
            response.items.forEach(function (item) {
                self.regionsItems[item.id] = { code: item.code, idCountry: item.idCountry, name: item.name };
            });
            self.update();
        }
    });
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/delivery/delivery-edit.tag